<img [@rotate180]="isOpen ? flipped : default" src="/assets/images/icons/chevron-down.svg" aria-hidden="true" />
